import { defineComponent as _defineComponent } from 'vue'
import Http from '@/core/http/http.service';
import QuickOrderFileEntryViewObject = Vertica.LouisPoulsen.Application.QuickOrder.ViewModels.QuickOrderFileEntryViewObject;
import QuickOrderValidateFileViewModel = Vertica.LouisPoulsen.Application.QuickOrder.ViewModels.QuickOrderValidateFileViewModel;
import QuickOrderMultiAddWebRequest = Vertica.LouisPoulsen.Application.QuickOrder.Requests.QuickOrderMultiAddWebRequest;
import QuickOrderMultiAddViewModel = Vertica.LouisPoulsen.Application.QuickOrder.ViewModels.QuickOrderMultiAddViewModel;
import { store } from '@/store';
import TrackingService from '@/core/tracking.service';
import { computed, onMounted, ref } from 'vue';

enum FileUploadStep {
    Loading,
    Upload,
    ErrorTable,
    Report
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickOrderFileUpload',
  setup(__props) {

const upload = ref<Vue>(null);

function fetchBasket() : void {
    store.dispatch('basket/fetchBasket');
}

const step = ref<number>(FileUploadStep.Upload);
const lines = ref<QuickOrderFileEntryViewObject[]>([]);
const showParseErrorMessage = ref<boolean>(false);
const successCount = ref<number>(0);
const reportErrors = ref<string[]>([]);

onMounted(() => {
    TrackingService.event('Ecommerce', 'Quick order csv', 'Open');
});

function onFileSelected(): void {
    const formData = new FormData();

    const element = upload.value.$refs.input as HTMLInputElement;
    for (let i = 0; i < element.files.length; i++) {
        formData.append('upload[]', element.files[i], element.files[i].name);
    }

    TrackingService.event('Ecommerce', 'Quick order csv', 'Upload');

    step.value = FileUploadStep.Loading;
    Http.post('quickorderfile/validatefile', formData).then((response: QuickOrderValidateFileViewModel) => {
        if (response.parseError) {
            step.value = FileUploadStep.Upload;
            showParseErrorMessage.value = true;

            TrackingService.event('Ecommerce', 'Quick order csv', 'Upload_error');
            return;
        }

        showParseErrorMessage.value = false;

        lines.value = response.lines;

        if (response.lineErrors) {
            TrackingService.event('Ecommerce', 'Quick order csv', 'Upload_error');
            step.value = FileUploadStep.ErrorTable;
        } else {
            TrackingService.event('Ecommerce', 'Quick order csv', 'Upload_success');
            sendValidProducts();
        }
    });
}

function sendValidProducts() {
    const validProduct = lines.value.filter(x => !x.hasError);

    const request: QuickOrderMultiAddWebRequest = { lines: [] };

    for (let i = 0; i < validProduct.length; i++) {
        const product = validProduct[i];
        request.lines.push({ id: product.id, quantity: parseInt(product.quantity, 10), comment: product.comment });
    }

    const hasSkippedLines = validProduct.length !== lines.value.length;
    if (hasSkippedLines) {
        TrackingService.event('Ecommerce', 'Quick order csv', 'Submit_error');
    } else {
        TrackingService.event('Ecommerce', 'Quick order csv', 'Submit_perfect');
    }

    step.value = FileUploadStep.Loading;
    Http.post('quickorderfile/multiadd', request).then((response: QuickOrderMultiAddViewModel) => {
        step.value = FileUploadStep.Report;
        fetchBasket();
        successCount.value = response.addedProducts;
        reportErrors.value = response.errors;
    });
}

function downloadTemplateFile() {
    window.open('/api/quickorderfile/template');
}

const hasValidProducts = computed<boolean>(() => {
    if (!lines.value || lines.value.length === 0) { return false; }

    return lines.value.some(x => !x.hasError);
});

const isLoadingStep = computed<boolean>(() => { return step.value === FileUploadStep.Loading; });
const isUploadStep = computed<boolean>(() => { return step.value === FileUploadStep.Upload; });
const isErrorTableStep = computed<boolean>(() => { return step.value === FileUploadStep.ErrorTable; });
const isReportStep = computed<boolean>(() => { return step.value === FileUploadStep.Report; });

function changeStepToUpload() {
    step.value = FileUploadStep.Upload;
}

return { __sfc: true,FileUploadStep, upload, fetchBasket, step, lines, showParseErrorMessage, successCount, reportErrors, onFileSelected, sendValidProducts, downloadTemplateFile, hasValidProducts, isLoadingStep, isUploadStep, isErrorTableStep, isReportStep, changeStepToUpload }
}

})